module.exports = __webpack_public_path__ + "static/img/tegelgrund.95369b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/GLU_Tegelgrund/tegelgrund.jpg
// module id = 3LPk
// module chunks = 0